export default __webpack_public_path__ + "static/media/Effortless ScalabilityLeft.ff73e5c3.png";